import React from 'react';
import HarbourModal from './harbour/HarbourModal';
import HarbourNotice from './harbour/HarbourNotice';

/*
 * The submit pop-up (Figma UAXOnhR1ZvlsNl4diy00xX, READY FOR DEV): the one
 * moment a respondent submits one pathway's forms (TDI-415, per pathway
 * since TDI-651).
 *   SENCO, SEND pathway: "Submit your forms · SENCO", S-1 5226:131473.
 *   Parent or carer, either pathway: "Submit your forms · Parent or carer",
 *   S-1 5226:392640 (mobile) / 5226:392831 (desktop) for SEND, 5226:392739 /
 *   5226:392929 for the referral.
 *
 * Wording is the frames' own. The lines the frames bracket ("Nothing happens
 * until…", "Check my answers first") are pending Jasmine's sign-off.
 */
export default function SubmitFormsModal({
  // How many forms this pathway asked the respondent for.
  count,
  // The frames' second line: the SENCO's reads "Nothing happens until you
  // submit them."; the parent's names the button.
  nothingHappensLine = 'Nothing happens until you choose Confirm and submit all responses.',
  // Optional sentence after the lock warning, e.g. when the profile is made.
  afterLine = null,
  // 'primary' (plum) on the SENCO portal, 'family' (gold) for a parent.
  actionKind = 'family',
  busy = false,
  // A failed submit: nothing was recorded, so say so and let them retry.
  error = false,
  onConfirm,
  onClose,
}) {
  return (
    <HarbourModal
      className="harbour-submit-modal"
      title={`All ${count} forms are answered`}
      confirmLabel="Confirm and submit all responses"
      confirmKind={actionKind}
      cancelLabel="Check my answers first"
      cancelKind="secondary"
      showClose={false}
      busy={busy}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      <div className="flex flex-col gap-4">
        <p className="harbour-body-16">
          Check and submit them.
          <br />
          {nothingHappensLine}
          <br />
          {`Once you submit, your answers are locked and can’t be changed.${afterLine ? ` ${afterLine}` : ''}`}
        </p>
        {error && (
          <HarbourNotice kind="error" title="We could not confirm your forms">
            Check your internet connection and try again. Nothing has been submitted yet.
          </HarbourNotice>
        )}
      </div>
    </HarbourModal>
  );
}
